// eslint-disable-next-line import/prefer-default-export
export const UPDATE_CLIENT_TAGS_LIST = 'UPDATE_CLIENT_TAGS_LIST';
